export const definedTranslation = {
  btnSpot: {
    id: 'btn-spot',
    defaultMessage: 'Grab a spot',
  },
  title: {
    about: {
      id: 'title-about',
      defaultMessage: 'About',
    },
    information: {
      id: 'title-information',
      defaultMessage: 'Information',
    },
    eventsBottom: {
      id: 'title-eventsBottom',
      defaultMessage: 'You might also like',
    },
  },
  label: {
    when: {
      id: 'label-when',
      defaultMessage: 'When',
    },
    where: {
      id: 'label-where',
      defaultMessage: 'Where',
    },
    organizingCompany: {
      id: 'label-organizingCompany',
      defaultMessage: 'Organizing company',
    },
    fees: {
      id: 'label-fees',
      defaultMessage: 'Fees',
    },
    registration: {
      id: 'label-registration',
      defaultMessage: 'Registration',
    },
    documentation: {
      id: 'label-documentation',
      defaultMessage: 'Documentation',
    },
  },
};
